import React from 'react';
import { Box, Typography } from '@mui/material';
import QuizLayout from '../../../../shared/reusables/QuizLayout';
import MultipleChoiceCard from '../../../../shared/reusables/MultipleChoiceCard';
import QuizEndScreen from '../../../../shared/reusables/QuizEndScreen';
import { useMultipleChoiceQuiz } from '../../../../shared/hooks/useQuiz';

/**
 * GenericMultipleChoiceMode — covers all word-category multiple-choice modes.
 *
 * Props:
 *   endpoint   {string}  API endpoint, e.g. "adjectives"
 *   label      {string}  Display label
 *   answerKey  {string}  Key on each word for the correct answer (default: "darija")
 *   onBack     {fn}
 */
export default function GenericMultipleChoiceMode({
    endpoint,
    label,
    answerKey = 'darija',
    onBack,
}) {
    const {
        order,
        currentIndex,
        options,
        selected,
        quizFinished,
        score,
        wrong,
        loading,
        error,
        currentWord,
        handleAnswer,
        resetQuiz,
    } = useMultipleChoiceQuiz(endpoint, answerKey);

    if (loading) return null;

    if (error) {
        return (
            <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography sx={{ color: '#f87171', fontFamily: "'DM Sans', sans-serif" }}>
                    ⚠️ {error}
                </Typography>
            </Box>
        );
    }

    if (order.length === 0 || !currentWord) return null;

    if (quizFinished) {
        return (
            <QuizEndScreen
                correct={score}
                total={order.length}
                wrongItems={wrong}
                onRetry={resetQuiz}
            />
        );
    }

    return (
        <QuizLayout
            current={currentIndex + 1}
            total={order.length}
            label={label}
            onBack={onBack}
        >
            <MultipleChoiceCard
                question={`Wat is ${currentWord.dutch}?`}
                accentWord={currentWord.dutch}
                options={options}
                selected={selected}
                correctAnswer={currentWord[answerKey]?.toLowerCase()}
                onAnswer={handleAnswer}
                current={currentIndex + 1}
                total={order.length}
                label={label}
                questionIndex={currentIndex}
            />
        </QuizLayout>
    );
}
